import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const primengAppThemePreset = definePreset(Aura, {
  components: {
    card: { body: { padding: '1.5rem', gap: '0.5rem' } },
    datatable: { columnTitle: { fontWeight: '500' }, sortIcon: { size: '14px' } },
    tag: {
      root: { borderRadius: '{border.radius.sm}', fontSize: '0.75rem', padding: '0.2rem 0.5rem' },
      icon: { size: '0.75rem' },
    },
    avatar: { root: { width: '2rem', height: '2rem', fontSize: '1rem' } },
    checkbox: {
      root: { borderRadius: '{border.radius.sm}' },
    },
    chip: {
      root: { borderRadius: '16px' },
    },
    radiobutton: {
      root: {
        checkedBackground: '{form.field.background}',
        checkedHoverBackground: '{form.field.background}',
      },
      icon: {
        checkedColor: '{primary.color}',
        checkedHoverColor: '{primary.hover.color}',
      },
    },
    multiselect: {
      option: {
        selectedBackground: 'transparent',
        selectedColor: 'var(--p-multiselect-option-color)',
        selectedFocusColor: 'var(--p-multiselect-option-color)',
      },
      chip: {
        borderRadius: '16px',
      },
    },
    divider: {
      horizontal: {
        margin: '1rem 0',
      },
    },
    inputnumber: {
      button: { width: '2.5rem' },
    },
    toggleswitch: {
      css: () => `
        .p-toggleswitch.p-disabled {
          opacity: 0.6;
        }
        .p-toggleswitch.p-disabled .p-toggleswitch-slider {
          background: dt('toggleswitch.background');
        }
        .p-toggleswitch.p-disabled .p-toggleswitch-handle {
          background: dt('toggleswitch.handle.background');
        }
        .p-toggleswitch.p-toggleswitch-checked.p-disabled .p-toggleswitch-slider {
          background: dt('toggleswitch.checked.background');
        }
        .p-toggleswitch.p-toggleswitch-checked.p-disabled .p-toggleswitch-handle {
          background: dt('toggleswitch.handle.checked.background');
        }
      `,
    },
    accordion: {
      css: () => `
        .p-accordioncontent > .p-motion {
          min-height: 0;
        }
      `,
    },
    message: {
      css: () => `
        .p-message .p-message-content:has(.p-message-text)::before {
          font-family: 'Font Awesome 6 Pro';
          font-weight: 900;
          font-style: normal;
          display: inline-flex;
          align-items: center;
          margin-inline-end: 0.375rem;
          flex-shrink: 0;
        }
        .p-message.p-message-info .p-message-content:has(.p-message-text)::before {
          content: "\\f05a";
        }
        .p-message.p-message-warn .p-message-content:has(.p-message-text)::before {
          content: "\\f071";
        }
        .p-message.p-message-error .p-message-content:has(.p-message-text)::before {
          content: "\\f057";
        }
        .p-message.p-message-success .p-message-content:has(.p-message-text)::before {
          content: "\\f058";
        }
      `,
    },
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});
